
import { groupOHLC, groupSeries } from './ChartTimeFrames';

const Point = (x, y) => {
    return { x: x, y: y }
}

const cdx = {

    mouseCrossHair: function (ctx, dtx, data = null) {

    },

    yTicks: (ctx, dtx, data = null) => {
        ctx.strokeStyle = 'rgba(255,255,255,0.1)';
        ctx.fillStyle = "#AAA"

        const { y } = dtx.scales
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";

        y.ticks(data.tickCount).forEach(d => {
            const yr = y(d)
            ctx.moveTo(0, yr + 0.5);
            ctx.lineTo(data.asAxis ? 5 : dtx.width, yr + 0.5);
            ctx.fillText(d, 8, yr + 0.5);
        });
    },

    xTicks: (ctx, dtx, data = null) => {
        ctx.strokeStyle = 'rgba(255,255,255,0.1)';
        ctx.fillStyle = "#AAA"

        const { x } = dtx.scales
        ctx.textAlign = "center";
        ctx.textBaseline = "hanging"

        x.ticks(data.tickCount).forEach(d => {
            const timeAsString = dtx.formatTime(d); // "June 30, 2015"
            ctx.moveTo(x(d), 0 + 0.5);
            ctx.lineTo(x(d), data.asAxis ? 8 : dtx.height + 0.5);
            if (1/*data.asAxis*/) {
                ctx.fillText(timeAsString, x(d), 10);
            }
        });
    },

    mouseCross: (ctx, dtx, data = null) => {
        if (!data.active) { return }
        ctx.strokeStyle = "rgba(255, 255, 255, 0.1"
        ctx.setLineDash([5, 3]);
        ctx.beginPath();
        ctx.moveTo(data.x, 0);
        ctx.lineTo(data.x, dtx.height);
        ctx.moveTo(0, data.y);
        ctx.lineTo(dtx.width, data.y);
        ctx.stroke();
    },

    markers: (ctx, dtx, data = null) => {
        const { y } = dtx.scales
        ctx.beginPath();
        data.markers.forEach((marker) => {
            cdx.rectangle(ctx, dtx, { center: { x: 0 + 30, y: y(marker.v) }, size: { w: 60, h: 16 }, color: "#ff3b14", v: marker.v })
        })
        ctx.stroke();
    },

    rectangle: (ctx, dtx, data = null) => {
        ctx.fillStyle = data.color
        ctx.moveTo(data.center.x - data.size.w * 0.5, data.center.y + data.size.h * 0.5)
        ctx.lineTo(data.center.x + data.size.w * 0.5, data.center.y + data.size.h * 0.5)
        ctx.lineTo(data.center.x + data.size.w * 0.5, data.center.y - data.size.h * 0.5)
        ctx.lineTo(data.center.x - data.size.w * 0.5, data.center.y - data.size.h * 0.5)
        ctx.lineTo(data.center.x - data.size.w * 0.5, data.center.y + data.size.h * 0.5)
    },

    ohlc: (ctx, dtx, data = null) => {
        const tf = { key: dtx.timeFrame.key, hours: 1 } //timeframe(dtx)
        if (!tf) {
            return
        }
        const { x, y } = dtx.scales
        const domain = x.domain()
        const timeframeData = data.getData(tf.key)

        const findFirst = (element) => {
            return element.date.getTime() >= domain[0]
        }
        const findLast = (element) => {
            return element.date.getTime() >= domain[1]
        }

        let first = timeframeData.ohlc.findIndex(findFirst)
        let last = timeframeData.ohlc.findIndex(findLast)

        let filtered = timeframeData.ohlc.slice(first, last)


        const widthPerDataEntry = dtx.width / filtered.length

        if (widthPerDataEntry < 1) {
            filtered = groupOHLC(filtered, Math.ceil(1 / widthPerDataEntry))
        }

        filtered.forEach((el, index) => {
            const timeX = x(el.date.getTime())
            const hp = Point(timeX, y(el.High))
            const lp = Point(timeX, y(el.Low))
            const cp = Point(timeX, y(el.Close))
            const op = Point(timeX, y(el.Open))
            cdx.candle(ctx, dtx, { ohlc: { h: hp, l: lp, c: cp, o: op }, maximumCandleWidth: widthPerDataEntry })
        })


        
        
        timeframeData.averages.forEach((avg) => {
            first = avg.findIndex(findFirst)
            last = avg.findIndex(findLast)

            ctx.beginPath()
            ctx.strokeStyle = "rgba(120, 204, 250, 0.2)"
            let filteredAverage = avg.slice(first, last)

            if (widthPerDataEntry < 1) {
                console.log("reduce")
                filteredAverage = groupSeries(filteredAverage, Math.ceil(1 / widthPerDataEntry))
                console.log(filteredAverage.length)
            }

            ctx.moveTo(x(filteredAverage[0].date.getTime()), y(filteredAverage[0].v))
            for (let i = 1; i < filteredAverage.length; i++) {
                
                const from = Point(x(filteredAverage[i - 1].date.getTime()), y(filteredAverage[i - 1].v))
                const to = Point(x(filteredAverage[i].date.getTime()), y(filteredAverage[i].v))

                var xc = (from.x + to.x) / 2;
                var yc = (from.y + to.y) / 2;
                

                if(filteredAverage.length < 100) {
                    ctx.quadraticCurveTo(to.x, to.y, xc, yc);
                } else {
                    ctx.lineTo(to.x, to.y)
            }
                }
                //
                //
                //
                
            ctx.stroke()
        })
        

    },



    candle: (ctx, dtx, data = null) => {
        const ohlc = data.ohlc

        const color = ohlc.c.y < ohlc.o.y ? '#60a54b' : '#a53b32'
        ctx.strokeStyle = color
        ctx.fillStyle = color

        ctx.beginPath();
        cdx.rectangle(ctx, dtx, {
            center:
            {
                x: ohlc.h.x,
                y: (ohlc.o.y + ohlc.c.y) * 0.5
            },
            size:
            {
                w: Math.max(1, data.maximumCandleWidth - 2),
                h: Math.abs(ohlc.o.y - ohlc.c.y)
            }
        })
        ctx.moveTo(ohlc.h.x, ohlc.h.y)
        ctx.lineTo(ohlc.l.x, ohlc.l.y)
        ctx.closePath();

        ctx.stroke()
        ctx.fill()
    },

    ohlcBar: (ctx, dtx, data = null) => {
        const ohlc = data.ohlc
        const color = ohlc.c.y < ohlc.o.y ? '#60a54b' : '#a53b32'
        ctx.strokeStyle = color
        ctx.beginPath();
        ctx.moveTo(ohlc.o.x - data.maximumCandleWidth * 0.5, ohlc.o.y)
        ctx.lineTo(ohlc.o.x, ohlc.o.y)
        ctx.moveTo(ohlc.c.x + data.maximumCandleWidth * 0.5, ohlc.c.y)
        ctx.lineTo(ohlc.c.x, ohlc.c.y)
        ctx.moveTo(ohlc.h.x, ohlc.h.y)
        ctx.lineTo(ohlc.l.x, ohlc.l.y)
        ctx.closePath();
        ctx.stroke()
    }
}

export default cdx;


// WEBPACK FOOTER //
// ./src/ChartDrawingContext.js